import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';

import '../../../styles/Icon.css';

class Icon extends Component {
  static propTypes = {
    iconId: PropTypes.string,
    entityType: PropTypes.string,
    icons: PropTypes.instanceOf(Map),
  }

  defaultIconMap = {
    elementType: 'icomoon icon-element-type',
    relationshipType: 'icomoon icon-rel-type',
  }

  selectIcon = () => {
    const { iconId, entityType, icons } = this.props;

    if (!iconId || !icons.size) {
      return (
        <i
          className={`${this.defaultIconMap[entityType]} default-icon`}
        ></i>
      );
    } else {
      const icon = icons.getIn([iconId, 'name']);

      return (
        <img
          alt=""
          className="custom-icon"
          src={require(`../../../static/icons/${icon}.svg`)}
        />
      );
    }
  }

  render() {
    return this.selectIcon();
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/ui/Icon/Icon.js